import React from 'react'

function Details() {
  return (
<>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<h1>This is Details Page</h1>


</>
    
  )
}

export default Details